import React, { useState } from "react";
import { fetchData } from "../axios_URL";
import "./CompanyTable.css"; // Import the CSS file

import AttachFileIcon from '@mui/icons-material/AttachFile';

import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Inventory2Icon from '@mui/icons-material/Inventory2';


const CompanyTable = ({ companies, refresh, fetchFiles }) => {
    const [selectedCompany, setSelectedCompany] = useState(null); // For viewing details
    const [editCompany, setEditCompany] = useState(null); // For editing
    const [confirmDelete, setConfirmDelete] = useState(null); // For delete confirmation
    const [confirmactiveemail, setConfirmactiveemail] = useState(null); // For delete confirmation
    const [message, setMessage] = useState(null);
    const handleDelete = async (id) => {
        try {
            await fetchData("POST", `/api/admin/companies/delete/${id}`);
            setConfirmDelete(null); // Close confirmation popup
            refresh((prev) => !prev); // Refresh the list
        } catch (error) {
            console.error("Error deleting company:", error);
        }
    };

    const handleEdit = async () => {
        try {
            await fetchData("PUT", `/api/admin/companies/${editCompany.id}`, editCompany);
            setEditCompany(null); // Close edit form popup
            refresh((prev) => !prev); // Refresh the list
        } catch (error) {
            console.error("Error editing company:", error);
        }
    };
    const refreshwindow = async () => {
      
            window.location.href = "/ ";
     
    };
    const closeModal = () => {
        setSelectedCompany(null);
        setEditCompany(null);
        setConfirmDelete(null);
        setConfirmactiveemail(null);
        setMessage("");
    };

    const handleSendactiveemail = async (id) => {
        try {
            await fetchData("Post", `/api/admin/companies/sendactivation/${id}`);
            setConfirmactiveemail(null); // Close confirmation popup
            refresh((prev) => !prev); // Refresh the list
        } catch (error) {
            setMessage("Fehler beim Senden der E-Mail an das Unternehmen");
            console.error("Error send email company:", error);
        }
    };
    return (
        <div className="company-table">
            <table>
                <thead>
                    <tr>
                        <th>Firmenname</th>
                        <th>E-Mail</th>
                        <th>Mitarbeiter</th>
                        <th>Module</th>
                        <th>Status</th>
                        <th>Startdatum</th>
                        <th>Enddatum</th>
                        <th>Pakete</th>
                        <th> </th>

                    </tr>
                </thead>
                <tbody>
                    {companies.map((company) => (
                        <tr key={company.id}>
                            <td>{company.companyname}</td>
                            <td>{company.companyemail}</td>
                            <td>{company.numberofemployee}</td>
                            <td>{company.numberofpackage === 1 ? "Stempel Uhr" : company.numberofpackage === 2 ? "Planungs" : company.numberofpackage}</td>
                            <td>
                                <span
                                    style={{
                                        color: company.status === "Active" && company.active === true ? "green" :
                                            company.status === "Active" && company.active === false ? "black" :
                                                company.status === "Pending" ? "orange" :
                                                    company.status === "Stop" ? "red" : "black", // Default color

                                        fontSize: "30px",
                                    }}
                                >
                                    ●
                                </span>
                                {company.status === "Active" && company.active === true ? "Aktiv" :
                                    company.status === "Active" && company.active === false ? "Wartet" :
                                        company.status === "Pending" ? "Ausstehend" :
                                            company.status === "Stop" ? "Gestoppt" : company.status}
                            </td>

                            <td>{company.startdate}</td>
                            <td>{company.enddate}</td>
                            <td>     {company.numberofemployee === 5 ? "Startpaket" :
                                company.numberofemployee === 10 ? "Mediumpaket" :
                                    company.numberofemployee === 30 ? "Premiumpaket" : "Enterprise"}  </td>

                            <td>

                                <button onClick={() => setSelectedCompany(company)}><RemoveRedEyeIcon /></button>
                                <button onClick={() => setEditCompany(company)}><EditIcon /></button>
                                <button onClick={() => setConfirmDelete(company)}><Inventory2Icon /></button>
                                <button onClick={() => fetchFiles(company.id)}><AttachFileIcon /></button>
                                <button style={{ backgroundColor: company.active ? "#4ECFF5" : "#05333F" }} onClick={() => setConfirmactiveemail(company)}><MarkEmailReadIcon /></button>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

          
            {/* Details Popup */}
            {selectedCompany && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modalscroll">
                            <div className="AddEmployeeHeader">Details des Unternehmens</div>

                            {[
                                { label: 'Firmenname', value: selectedCompany.companyname },
                                { label: 'E-Mail', value: selectedCompany.companyemail },
                                { label: 'Vorname', value: selectedCompany.firstname },
                                { label: 'NachName', value: selectedCompany.lastname },
                                { label: 'Telefonnummer', value: selectedCompany.telephone_number },
                                { label: 'Straße', value: selectedCompany.street },
                                { label: 'Postleitzahl', value: selectedCompany.postalCode },
                                { label: 'Stadt', value: selectedCompany.city },
                                { label: 'Region', value: selectedCompany.region },
                                { label: 'Land', value: selectedCompany.country },
                                { label: 'Zusätzliche Adresse', value: selectedCompany.additionaladdress },
                                { label: 'Status', value: selectedCompany.status },
                                { label: 'Anzahl der Mitarbeiter', value: selectedCompany.numberofemployee },
                                { label: 'Module', value: selectedCompany.numberofpackage === 1 ? 'Stempel Uhr' : selectedCompany.numberofpackage === 2 ? 'Planungs' : selectedCompany.numberofpackage },
                                { label: 'Erstellungsdatum', value: selectedCompany.createdate },
                                { label: 'Startdatum', value: selectedCompany.startdate },
                                { label: 'Enddatum', value: selectedCompany.enddate },
                                {
                                    label: 'Pakete',
                                    value:
                                        selectedCompany.numberofemployee === 5 ? "Startpaket" :
                                            selectedCompany.numberofemployee === 10 ? "Mediumpaket" :
                                                selectedCompany.numberofemployee === 30 ? "Premiumpaket" : "Enterprise"
                                },
                                { label: 'Aktiv', value: selectedCompany.active ? 'Yes' : 'No' }
                            ].map(({ label, value }) => (
                                <LabelValue key={label} label={label} value={value} />
                            ))}

                            <button className="close-button" onClick={closeModal}>Schließen</button>
                            <button onClick={() => setConfirmactiveemail(selectedCompany)}><MarkEmailReadIcon /></button>
                        </div>
                    </div>
                </div>
            )}


            {/* Edit Popup */}
            {editCompany && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modalscroll">
                            <div className="AddEmployeeHeader">Unternehmen bearbeiten</div>
                            <form onSubmit={(e) => { e.preventDefault(); handleEdit();   }}>
                                {[
                                    { label: 'Firmenname', type: 'text', field: 'companyname' },
                                    { label: 'E-Mail', type: 'email', field: 'companyemail' },
                                    { label: 'Vorname', type: 'text', field: 'firstname' },
                                    { label: 'NachName', type: 'text', field: 'lastname' },
                                    { label: 'Telefonnummer', type: 'text', field: 'telephone_number' },
                                    { label: 'Straße', type: 'text', field: 'street' },
                                    { label: 'Postleitzahl', type: 'text', field: 'postalCode' },
                                    { label: 'Stadt', type: 'text', field: 'city' },
                                    { label: 'Region', type: 'text', field: 'region' },
                                    { label: 'Land', type: 'text', field: 'country' },
                                    { label: 'Zusätzliche Adresse', type: 'text', field: 'additionaladdress' },

                                ].map(({ label, type, field }) => (

                                    <FormInput
                                        key={field}
                                        label={
                                            field === 'startdate' ? (
                                                <>
                                                    {label} <span style={{ color: 'red' }}>*</span>
                                                </>
                                            ) : (
                                                label
                                            )
                                        }
                                        type={type}
                                        value={editCompany[field]}
                                        fieldName={field}
                                        onChange={(fieldName, value) => setEditCompany({ ...editCompany, [fieldName]: value })}
                                    />
                                ))}
                                <div className="form-group">
                                    <label>Module:</label>
                                    <select
                                        value={editCompany.numberofpackage}
                                        onChange={(e) => setEditCompany({ ...editCompany, numberofpackage: parseInt(e.target.value, 10) })}
                                    >
                                        <option value={1}>Stempel Uhr</option>
                                        <option value={2}>Planungs</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Pakete:</label>
                                    <select
                                        defaultValue=""
                                        onChange={(e) =>
                                            setEditCompany({
                                                ...editCompany,
                                                numberofemployee: parseFloat(e.target.value, 10) || "",
                                            })
                                        }
                                    >
                                        <option value="">Enterprise</option>
                                        <option value={5}>Startpaket</option>
                                        <option value={10}>Mediumpaket</option>
                                        <option value={30}>Premiumpaket</option>
                                        
                                    </select>

                                </div>
                                {[

                                    { label: 'Anzahl der Mitarbeiter', type: 'number', field: 'numberofemployee' },

                                    { label: 'Startdatum', type: 'date', field: 'startdate' },
                                    { label: 'Enddatum', type: 'date', field: 'enddate' }
                                ].map(({ label, type, field }) => (

                                    <FormInput
                                        key={field}
                                        label={
                                            field === 'startdate' ? (
                                                <>
                                                    {label} <span style={{ color: 'red' }}>*</span>
                                                </>
                                            ) : (
                                                label
                                            )
                                        }
                                        type={type}
                                        value={editCompany[field]}
                                        fieldName={field}
                                        onChange={(fieldName, value) => setEditCompany({ ...editCompany, [fieldName]: value })}
                                    />
                                ))}


 
                                <div className="form-actions"> 
                                    <button disabled={editCompany['startdate'] === null} style={{ backgroundColor: editCompany.active ? "#4ECFF5" : "#05333F" }} onClick={() => {  handleEdit(); setConfirmactiveemail(editCompany); }}><MarkEmailReadIcon /></button>
                                    <button type="submit">Speichern</button>
                                    <button type="button" onClick={closeModal}>Abbrechen</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}


            {/* Delete Confirmation Popup */}
            {
                confirmDelete && (
                    <div className="modal-overlay">
                        <div className="modal">
                            <div className="modal-content">
                                <div className='AddEmployeeHeader'>
                                    Bestätigung der archiveren
                                </div>

                                <p>Sind Sie sicher, dass Sie das Unternehmen archiveren möchten "{confirmDelete.companyname}"?</p>
                                <div className="form-actions">
                                    <button onClick={() => handleDelete(confirmDelete.id)}>Ja, archiveren</button>
                                    <button onClick={closeModal}>Abbrechen</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                confirmactiveemail && (
                    <div className="modal-overlay">
                        <div className="modal">
                            <div className="modal-content">
                                <div className='AddEmployeeHeader'>
                                    Bestätigung der send
                                </div>

                                <p>  Sind Sie sicher, dass Sie eine E-Mail an den Kunden senden möchten?</p>
                                <div className="form-actions">

                                    <button
                                        onClick={() => handleSendactiveemail(confirmactiveemail.id)}
                                        disabled={!(  confirmactiveemail['startdate'] != null&&confirmactiveemail.status === "Active")}

                                    >
                                        Ja
                                    </button>
                                    <button onClick={closeModal}>Abbrechen</button>
                                </div>
                                <p style={{ color: "red" }}>{message}</p>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );
};


const LabelValue = ({ label, value }) => (
    <div className="form-group">
        <label><strong>{label}:</strong></label>
        <label>{value}</label>
    </div>
);

const FormInput = ({ label, type, value, onChange, fieldName }) => (
    <div className="form-group">
        <label>{label}:</label>
        <input
            type={type}
            value={value || ""}
            onChange={(e) => onChange(fieldName, e.target.value)}
        />
    </div>
);

export default CompanyTable;